module.exports = __webpack_public_path__ + "static/hospital_support_card_img1@2x-47049c1fafc01bdb5a4f1de8efd1a5b8.jpg";